export default {
    setWebhooksList(state, data) {
        state.webhooksList = data
    },
}
